
import { Drawer } from "element-ui"
import NP from "number-precision"
// import drawerHeader from "./drawer-header.vue"
import countControl from "./count-control.vue"
import { COLLECT_INIT_WIDTH, GTM_REDEMPTION } from "./const.js"
import slotWidget from "./slot-widget"
import drawerHeader from "@/components/drawer/components/drawerHeader.vue"
import { handleAddToCartV2, handleModifyCartV2 } from "@/utils/cartResponse"
import { trackSelectItem } from "@/utils/track"

export default {
  API: ["open"],
  components: {
    [Drawer.name]: Drawer,
    drawerHeader,
    slotWidget,
    countControl
  },
  inject: {
    getProId: {
      default: null
    },
    getStoreId: {
      default: null
    },
    source: {
      default: null
    }
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    storeId: {
      type: [String, Number],
      default: ""
    },
    proId: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      visible: false,
      drawerSize: COLLECT_INIT_WIDTH,
      list: [],
      slotList: [],
      giftList: [] // 赠品列表
    }
  },
  computed: {
    isMax() {
      let isMax = false
      if (this.info.submitButtonShow) {
        isMax = this.list.length >= this.info.maxTradeQty || !this.info.maxTradeQty
      } else {
        isMax = this.info.selectedCount === this.info.maxTradeQty || !this.info.maxTradeQty
      }
      return isMax
    },
    isFull() {
      return this.list.length % this.info.rewardItemNum == 0
    },
    isChange() {
      return this._getWares().length > 0
    }
  },
  watch: {
    info: {
      handler(newVal) {
        console.log(newVal, "newValnewVal")
        if (newVal) {
          // 由于有前端操作，把如下数据同步到实例里
          this.list =
            newVal.selectedItemInfo && newVal.selectedItemInfo.flattenList
              ? newVal.selectedItemInfo.flattenList.filter(v => !v.emptyData)
              : []
          this.slotList = newVal.selectedItemInfo ? newVal.selectedItemInfo.list : [] // 插槽展示位数据
          this.giftList = JSON.parse(JSON.stringify(newVal.optItemList)) // 可选赠品数据
          if (this.prevInfo && JSON.stringify(this.prevInfo) !== "{}") {
            if (newVal.maxTradeQty > 0 && this.prevInfo) {
              // 前一次的dialogInfo.proNum或者dialogInfo.maxTradeQty 与当前接口返回的不相同
              if (this.prevInfo.proNum != newVal.proNum || this.prevInfo.maxTradeQty != newVal.maxTradeQty) {
                this.open()
              }
            }
          } else {
            // 第一次进入
            if (newVal.maxTradeQty && newVal.maxTradeQty != newVal.selectedCount) {
              this.open()
            }
          }
          this.prevInfo = newVal
        }
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    handleGroupSlotDelete({ skuId, index }, groupIndex) {
      this.$set(this.slotList[groupIndex], index, {
        ...this.slotList[groupIndex][index],
        emptyData: true
      })
      this.list.splice(index, 1)
      this.giftList.forEach((v, i) => {
        if (v.skuId == skuId) {
          this.giftList[i].count--
        }
      })
    },
    handleSlotDelete({ skuId }, groupIndex) {
      this.$set(this.slotList, groupIndex, {
        ...this.slotList[groupIndex],
        emptyData: true
      })
      this.list.splice(index, 1)
      this.giftList.forEach((v, i) => {
        if (v.skuId == skuId) {
          this.giftList[i].count--
        }
      })
    },
    getAbnormalStateText(item) {
      const state = item?.merchantId
      switch (state) {
        case 0:
          // 仅香港
          return this.$t("cart.salesAreaOnlyHKPickUp")
        case 1:
          // 仅澳门
          return this.$t("cart.salesAreaOnlyMacaoPickUp")
        default:
          return ""
      }
    },
    handleGoDetail(val) {
      val.parentId = GTM_REDEMPTION
      val.layoutName = GTM_REDEMPTION
      trackSelectItem(val, () => {
        this.$navigation.push(
          `${this.MAIN_ORIGIN}${this.MAIN_PATH}/p/${encodeURIComponent(val.wareName)}/i/${val.skuId}.html`
        )
      })
    },
    handleCountIncrease(val) {
      this.list.unshift({
        ...val
      })
      this.giftList.forEach((v, i) => {
        if (v.skuId == val.skuId) {
          this.giftList[i].count++
        }
      })
      this.asyncItemToSlot()
    },
    handleCountReduce(val) {
      const index = this.list.findIndex(v => v.skuId == val.skuId)
      this.list.splice(index, 1)
      this.giftList.forEach((v, i) => {
        if (v.skuId == val.skuId) {
          this.giftList[i].count--
        }
      })
      this.slotList = JSON.parse(JSON.stringify(this.info.selectedItemInfo.emptyList))
      this.asyncItemToSlot()
    },
    // 将操作后的赠品列表同步到插槽中
    asyncItemToSlot() {
      if (this.info.selectedItemInfo && this.info.selectedItemInfo.showGroup) {
        let count = this.list.length - 1
        for (let i = this.slotList.length - 1; i >= 0; i--) {
          if (count < 0) {
            break
          }
          if (count < this.slotList[i].length) {
            // 没填满的从前开始填充
            let index = 0
            while (index <= count) {
              this.$set(this.slotList[i], index, {
                ...this.list[index]
              })
              index++
            }
            break
          } else {
            // 从后向前填充
            for (let j = this.slotList[i].length - 1; j >= 0; j--) {
              if (this.list[count]) {
                this.$set(this.slotList[i], j, {
                  ...this.list[count]
                })
                count--
              }
            }
          }
        }
      } else {
        let index = this.slotList.length - 1
        let count = this.list.length - 1
        while (count >= 0) {
          this.$set(this.slotList, index, {
            ...this.list[count]
          })
          index--
          count--
        }
      }
    },
    open() {
      this.visible = true
      this.$bus.$emit("inner-drawer", true)
    },
    handleClose() {
      this.$bus.$emit("inner-drawer", false)
      this.visible = false
    },
    async handleRedeemNow() {
      if (!this.isChange) return
      const [error, data] = await handleModifyCartV2({
        storeId: this.storeId || (this.getStoreId && this.getStoreId()),
        wares: this._getWares(),
        sort: 1,
        otherParams: {
          tradeProId: this.proId || (this.getProId && this.getProId())
        }
      })
      if (error) {
        // this.$message.error(error.result)
      }
      if (data) {
        this.$bus.$emit("add-cart-success", this.source)
        if (this.source === "collect") {
          this.$bus.$emit("reload-collect")
        }
        this.handleClose()
      }
    },
    handleSelect(val, canSelect) {
      if (!canSelect) return
      if (this.info.submitButtonShow) {
        this.list.unshift({
          ...val
        })
        // 修过列表里面的数量
        this.giftList.forEach((v, i) => {
          if (v.skuId == val.skuId) {
            this.giftList[i].count = 1
          }
        })
        this.asyncItemToSlot()
      } else {
        this.handleAddCart(val)
      }
    },
    async handleAddCart(item) {
      const loading = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
      const [error, data] = await handleAddToCartV2({
        storeId: this.storeId || (this.getStoreId && this.getStoreId()),
        wares: [{ sku: item.skuId, beforeCount: 0, count: 1, checked: 1 }],
        sort: 1,
        otherParams: {
          tradeProId: this.proId || (this.getProId && this.getProId())
        }
      })
      if (error) {
        // this.$message.error(error.result)
      }
      if (data) {
        this.$bus.$emit("add-cart-success", this.source)
        if (this.source === "collect") {
          this.$bus.$emit("reload-collect")
        }
        this.count = 1
      }
      loading.close()
    },
    _fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },
    _getWares() {
      const wares = []
      // 先将初始值同步到 wares
      if (this.info.optItemList) {
        this.info.optItemList.forEach(v => {
          wares.push({
            sku: v.skuId,
            count: 0,
            checked: 1,
            beforeCount: v.count || 0,
            name: v.wareName,
            price: v.unitOriginPrice
          })
        })
      }
      this.list.forEach(v => {
        const index = wares.findIndex(_v => _v.sku == v.skuId)
        if (index >= 0) {
          wares[index].count++
        }
      })
      return wares.filter(v => v.count != v.beforeCount)
    }
  }
}
